(function() {
  "use strict";

  angular.module("app").directive("cccRaceEthnoCharts", cccRaceEthnoCharts);

  function cccRaceEthnoCharts() {
    return {
      restrict: "EA",
      scope: false,
      controller: "RaceEthnoChartsController"
    };
  }
})();
